import styled from "@emotion/styled";
import { Box } from "../../../primitives/Box/Box";
import { Flex } from "../../../primitives/Flex/Flex";

interface HeaderContainerProps {
  bgColor?: string;
}

export const HeaderContainer = styled(Flex)<HeaderContainerProps>`
  background: ${(props) => props.bgColor || "background.default.default"};
`;

export const BackButton = styled(Box)`
  cursor: pointer;
`;
